import axios from 'axios';
import { api } from '@/store/service';

const InitialState = {
  sid: '',
  wmid: '',
  username: '',
};

const mutations = {
  update(state, sid) {
    return Object.assign(state, { sid });
  },
  updateWmid(state, wmid) {
    return Object.assign(state, { wmid });
  },
  updateUsername(state, username) {
    return Object.assign(state, { username });
  },
};

const actions = {
  async verifySid({ commit }) {
    try {
      const response = await axios({
        url: `${process.env.QMEDIA.QMEDIA_URL}${this.state.qmedia.wmid}?sid=${this.state.qmedia.sid}`,
        method: 'get',
      });
      return response.data;
    } catch (error) {
      const qmedia = await api('post', 'marketData/authenticate');
      commit('update', qmedia.sid);
      return qmedia;
    }
  },
  async createAccount({ commit }) {
    try {
      const response = await api('post', 'marketDataAccounts', {});
      commit('updateWmid', response.qm_webmaster_id);
      commit('updateUsername', response.qm_username);
      commit('update', '');
      return response;
    } catch (error) {
      return {};
    }
  },
};

const getters = {
  sid: (state) => state.sid,
};

export default {
  state: InitialState,
  mutations,
  actions,
  getters,
  namespaced: true,
};
